import React from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import logoProject from "./logo-project.svg";

import homeDetailList from "./../../shared/content/homeDetail.json";
import zoneList from "./../../shared/content/homeZone.json";

import { CardHomeDetail, CardHomeItem } from "./../../shared/components";

const Container = styled.div`
  max-width: 1248px;
  width: 100%;
  padding: 0;
  margin: 0 auto;
`;

const CardHomeDetailContainer = styled.div`
  padding: 0 1rem;
`;

const HomeZoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  padding-top: 30px;
  padding: 0 1rem;
  padding-bottom: 30px;
  text-align: left;
`;

const HomeListContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
`;

const LogoContainer = styled.div`
margin-top: 30px;
  padding: 0 1rem;
  text-align: center;
  & .the-neighbours-logo {
    height: 80px;
  }
`;

const HomeDetail = (props) => {
  const { id } = useParams();
  const homeDetail = homeDetailList.filter((item) => item.url == id);
  const homeZoneDetail = zoneList.filter(
    (item) => item.zone_name == homeDetail[0].zone_name
  );
  const homeZoneList = homeZoneDetail[0].home.filter(
    (item) => item.url != homeDetail[0].url
  );
  
  return (
    <>
      <Container>
        <CardHomeDetailContainer>
          <CardHomeDetail data={homeDetail[0]} />
        </CardHomeDetailContainer>
      </Container>
      <HomeZoneContainer>
        <LogoContainer>
          <img src={logoProject} className="the-neighbours-logo" alt="logo" />
        </LogoContainer>
        <Container>
          <h3 style={{ margin: "20px 0" }}>Other the neighbors</h3>
          <HomeListContainer>
            {homeZoneList.map((home) => (
              <CardHomeItem data={home} />
            ))}
            {3 - homeZoneList.length == 3 ? (
              <>
                <CardHomeItem
                  data={
                    homeDetailList[
                      Math.floor(Math.random() * homeDetailList.length)
                    ]
                  }
                />
                <CardHomeItem
                  data={
                    homeDetailList[
                      Math.floor(Math.random() * homeDetailList.length)
                    ]
                  }
                />
                <CardHomeItem
                  data={
                    homeDetailList[
                      Math.floor(Math.random() * homeDetailList.length)
                    ]
                  }
                />
              </>
            ) : 3 - homeZoneList.length == 2 ? (
              <>
                <CardHomeItem
                  data={
                    homeDetailList[
                      Math.floor(Math.random() * homeDetailList.length)
                    ]
                  }
                />
                <CardHomeItem
                  data={
                    homeDetailList[
                      Math.floor(Math.random() * homeDetailList.length)
                    ]
                  }
                />
              </>
            ) : (
              <CardHomeItem
                data={
                  homeDetailList[
                    Math.floor(Math.random() * homeDetailList.length)
                  ]
                }
              />
            )}
          </HomeListContainer>
        </Container>
      </HomeZoneContainer>
    </>
  );
};

export default HomeDetail;
